import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import { Controller, useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { PulseLoader } from "react-spinners";
import { SubscribeButton, SubscribeInput } from "styles/jss/Footer.styles";
import { subscribe } from "services/common.api";
import { useMutation } from "@tanstack/react-query";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useContext } from "react";
import { RecaptchaContext } from "Hook/recaptchaContext";

const validationSchema = yup.object().shape({
  email: yup.string().email().required("Email Field is Required"),
});

export default function SubsForm() {
  const { t } = useTranslation(["footer"]);
  const { locale } = useRouter();

  const {
    control,
    reset,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  const { mutate, isLoading } = useMutation({
    mutationFn: data => subscribe(data).then(res => console.log(res)),
    onError: error => {
      // An error happened!
      toast.error(error?.message?.toString());
    },
    onSuccess: () => {
      // Boom baby!
      toast.success(t("success"));
      reset();
    },
  });

  const { loading, handleRecaptcha } = useContext(RecaptchaContext);

  const onSubmit = async data => {
    const captchaRes = await handleRecaptcha();
    if (captchaRes.status !== "success") return null;

    const body = {
      data: { ...data, locale },
    };
    mutate(body);
  };

  return (
    <form>
      <Controller
        name="email"
        control={control}
        defaultValue=""
        render={({ field }) => (
          <SubscribeInput
            {...field}
            className="subscribe"
            type="email"
            placeholder="example@yourdomain.com"
            error={!!errors["email"]}
          />
        )}
      />
      <SubscribeButton
        disableElevation
        variant="contained"
        onClick={handleSubmit(onSubmit)}
        disabled={isLoading}
      >
        {loading || isLoading ? (
          <PulseLoader color="#17479e" size={8} />
        ) : (
          t("subscribe")
        )}
      </SubscribeButton>
    </form>
  );
}
